<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ser">
<img alt="" height="20%" src="Images/EAPlogo.jpg" width="20%"/>
<p>Early American Places is a collaborative project of the University of Georgia Press, New York University Press, Northern Illinois University Press, and the University of Nebraska Press. The series is supported by the Andrew W. Mellon Foundation. For more information, please visit <a class="url" href="http://www.earlyamericanplaces.org" target="_blank">www.earlyamericanplaces.org</a>.</p>
<p><br/></p>
<p>Advisory Board</p>
<p>Vincent Brown, <i>Duke University</i></p>
<p>Stephanie M. H. Camp, <i>University of Washington</i></p>
<p>Andrew Cayton, <i>Miami University</i></p>
<p>Cornelia Hughes Dayton, <i>University of Connecticut</i></p>
<p>Nicole Eustace, <i>New York University</i></p>
<p>Amy S. Greenberg, <i>Pennsylvania State University</i></p>
<p>Ramón A. Gutiérrez, <i>University of Chicago</i></p>
<p>Peter Charles Hoffer, <i>University of Georgia</i></p>
<p>Karen Ordahl Kupperman, <i>New York University</i></p>
<p>Joshua Piker, <i>College of William &amp; Mary</i></p>
<p>Mark M. Smith, <i>University of South Carolina</i></p>
<p>Rosemarie Zagarri, <i>George Mason University</i></p><a class="page" id="pii"></a><a class="page" id="piii"></a><a class="page" id="piv"></a><a class="page" id="pv"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hardesty-0002.vue?82ff6b48